(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ishi_megamenu"]) return;
  try {
    
document.addEventListener('click', function(event) {
  if (!window.matchMedia('(max-width:991px)').matches) return;
  const control=event.target.closest('#mobile_top_menu_wrapper [data-te-menu-toggle], #mobile_top_menu_wrapper .category > .dropdown-item[href=""]');
  if (!control) return;
  const category=control.closest('.category');
  const toggle=category.querySelector('[data-te-menu-toggle]');
  const panel=category.querySelector('.js-sub-menu');
  if (!toggle || !panel) return;
  event.preventDefault();event.stopImmediatePropagation();
  const opening=toggle.getAttribute('aria-expanded')!=='true';
  if (opening) category.parentElement.querySelectorAll('[data-te-menu-toggle][aria-expanded="true"]').forEach(other=>{
    if (other===toggle) return;
    const otherPanel=other.closest('.category').querySelector('.js-sub-menu');
    other.setAttribute('aria-expanded','false');other.classList.add('ishi-collapsed');
    if(otherPanel){otherPanel.classList.remove('in');otherPanel.style.display='none';}
  });
  panel.classList.toggle('in',opening);
  panel.style.display=opening?'block':'none';
  toggle.setAttribute('aria-expanded',String(opening));
  toggle.classList.toggle('ishi-collapsed',!opening);
}, true);
document.addEventListener('keydown',function(event){
  if(event.key!=='Escape'||!window.matchMedia('(max-width:991px)').matches) return;
  const panel=event.target.closest('#mobile_top_menu_wrapper .js-sub-menu.in');
  const toggle=event.target.closest('#mobile_top_menu_wrapper [data-te-menu-toggle][aria-expanded="true"]')||(panel&&panel.closest('.category').querySelector('[data-te-menu-toggle]'));
  if(!toggle) return;
  const section=toggle.closest('.category').querySelector('.js-sub-menu');
  event.preventDefault();event.stopImmediatePropagation();
  section.classList.remove('in');section.style.display='none';toggle.setAttribute('aria-expanded','false');toggle.classList.add('ishi-collapsed');toggle.focus();
},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-bedroom-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('te-bedroom-shop')){
customElements.define('te-bedroom-shop',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.group='all';
this.grid=this.querySelector('.te-bedroom__grid');this.cards=[...this.querySelectorAll('.te-bedroom__card')];
this.buttons=[...this.querySelectorAll('[data-group]')];
this.buttons.forEach(button=>button.addEventListener('click',()=>{this.group=button.dataset.group;this.update();}));
this.querySelector('[data-sort]').addEventListener('change',event=>{const url=new URL(window.location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');url.hash=this.querySelector('[data-sort]').closest('[id]').id;window.location.assign(url.href);});
this.update();
}
update(){
const order=this.querySelector('[data-sort]').value;
const cards=[...this.cards];
if(order==='low')cards.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
if(order==='high')cards.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
if(order==='az')cards.sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name));
let count=0;
cards.forEach(card=>{card.hidden=this.group!=='all'&&!card.dataset.category.split(' ').includes(this.group);if(!card.hidden)count++;this.grid.append(card);});
this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.group===this.group)));
this.querySelector('[data-count]').textContent=this.querySelector('[data-count]').dataset.format.replace('[count]',count);
this.querySelector('.te-bedroom__empty').hidden=count!==0;
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-beds-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('te-bed-shop')){
customElements.define('te-bed-shop',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.group='all';
this.grid=this.querySelector('.te-beds__grid');this.cards=[...this.querySelectorAll('.te-beds__card')];
this.buttons=[...this.querySelectorAll('[data-group]')];
this.buttons.forEach(button=>button.addEventListener('click',()=>{this.group=button.dataset.group;this.update();}));
this.querySelector('[data-sort]').addEventListener('change',event=>{const url=new URL(window.location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');url.hash=this.querySelector('[data-sort]').closest('[id]').id;window.location.assign(url.href);});
this.update();
}
update(){
const order=this.querySelector('[data-sort]').value;
const cards=[...this.cards];
if(order==='low')cards.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
if(order==='high')cards.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
if(order==='az')cards.sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name));
let count=0;
cards.forEach(card=>{card.hidden=this.group!=='all'&&!card.dataset.category.split(' ').includes(this.group);if(!card.hidden)count++;this.grid.append(card);});
this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.group===this.group)));
this.querySelector('[data-count]').textContent=this.querySelector('[data-count]').dataset.format.replace('[count]',count);
this.querySelector('.te-beds__empty').hidden=count!==0;
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-category-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('te-category-shop')){customElements.define('te-category-shop',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const categoryToggle=this.querySelector('[data-toggle-categories]');if(categoryToggle){categoryToggle.addEventListener('click',()=>{const extras=this.querySelector('[data-extra-categories]');const expanded=categoryToggle.getAttribute('aria-expanded')!=='true';extras.hidden=!expanded;categoryToggle.setAttribute('aria-expanded',String(expanded));categoryToggle.parentElement.toggleAttribute('data-expanded',expanded);});}this.querySelector('[data-sort]')?.addEventListener('change',event=>{const url=new URL(window.location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');url.hash='category-products';window.location.assign(url.href);});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-mattress-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('te-mattress-shop')){
customElements.define('te-mattress-shop',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.group='all';
this.grid=this.querySelector('.te-mattresses__grid');this.cards=[...this.querySelectorAll('.te-mattresses__card')];
this.buttons=[...this.querySelectorAll('[data-group]')];
this.buttons.forEach(button=>button.addEventListener('click',()=>{this.group=button.dataset.group;this.update();}));
this.querySelector('[data-sort]').addEventListener('change',event=>{const url=new URL(window.location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');url.hash=this.querySelector('[data-sort]').closest('[id]').id;window.location.assign(url.href);});
this.update();
}
update(){
const order=this.querySelector('[data-sort]').value;
const cards=[...this.cards];
if(order==='low')cards.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
if(order==='high')cards.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
if(order==='az')cards.sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name));
let count=0;
cards.forEach(card=>{card.hidden=this.group!=='all'&&!card.dataset.category.split(' ').includes(this.group);if(!card.hidden)count++;this.grid.append(card);});
this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.group===this.group)));
this.querySelector('[data-count]').textContent=this.querySelector('[data-count]').dataset.format.replace('[count]',count);
this.querySelector('.te-mattresses__empty').hidden=count!==0;
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-pets-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('te-pet-shop')){
customElements.define('te-pet-shop',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.group='all';
this.grid=this.querySelector('.te-pets__grid');this.cards=[...this.querySelectorAll('.te-pets__card')];
this.buttons=[...this.querySelectorAll('[data-group]')];
this.buttons.forEach(button=>button.addEventListener('click',()=>{this.group=button.dataset.group;this.update();}));
this.querySelector('[data-sort]').addEventListener('change',event=>{const url=new URL(window.location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');url.hash=this.querySelector('[data-sort]').closest('[id]').id;window.location.assign(url.href);});
this.update();
}
update(){
const order=this.querySelector('[data-sort]').value;
const cards=[...this.cards];
if(order==='low')cards.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
if(order==='high')cards.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
if(order==='az')cards.sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name));
let count=0;
cards.forEach(card=>{card.hidden=this.group!=='all'&&card.dataset.category!==this.group;if(!card.hidden)count++;this.grid.append(card);});
this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.group===this.group)));
this.querySelector('[data-count]').textContent=this.querySelector('[data-count]').dataset.format.replace('[count]',count);
this.querySelector('.te-pets__empty').hidden=count!==0;
}
});
}

  } catch(e) { console.error(e); }
})();
})();
